import React, { useState, useEffect } from "react";
import {
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Form,
  FormGroup,
  Button,
  Table,
  Alert,
  UncontrolledAccordion,
} from "reactstrap";
import classnames from "classnames";
import { useSelector, useDispatch } from "react-redux";
import AssesmentTab from "./TabsComponents/AssesmentTab";
import ViewVendorSupplierNeedForm from "../VendorNeedList/ViewVendorSupplierNeedForm";
import TooltipCustom from "../../common/Tooltip";
import PopupMsgWrapper from "../../common/PopupMsgWrapper";
import { Controller, useForm } from "react-hook-form";
import {
  fetchQuestionList,
  fetchReviewRequestResponseforApprover,
  getApplicationStepStatusBar,
  initiateRequestForCorrection,
  saveSelfAssesment,
} from "./TabsComponents/Action";
import Toaster from "../../common/Toaster";
import { useHistory } from "react-router-dom";
import FileUploadSelfAssesment from "./FileUploadSelfAssesment";
import { userDetails } from "../../../helper";
import LoaderCustom from "../../common/LoaderCustom";
import FileUploadSelfAssesmentRequestor from "./FileUploadSelfAssesmentRequestor";
import Nsa from "../NsaAudit/NSA";
import NeedFormReviewRequest from "../L1Approver/Level1Approver/Level1Tabs/NeedFormReviewRequest/NeedFormReviewRequest";
import KysOne from "../L1Approver/Level1Approver/Level1Tabs/KysOne/KysOne";
import KysTwo from "../L1Approver/Level1Approver/Level1Tabs/KysTwo/KysTwo";
import KysOneView from "../L1Approver/Level1Approver/Level1Tabs/KysOne/KysOneView/KysOneView";
// import VendorNeedApproval from "../L1Approver/Level1Approver/Level1Tabs/VendorNeedApproval";
import KysTwoApproval from "../L1Approver/Level1Approver/Level1Tabs/KysTwoApproval";
import VendorNeedApprovalHavells from "../L1Approver/Level1Approver/Level1Tabs/VendorNeedApproval";
import axiosHelper from "../../../axiosHelper";
import { API } from "../../../config/constants";
import KysTwoExceptionalApprovalList from "../L1Approver/Level1Approver/Level1Tabs/KysTwoExceptionalApprovalList";
import ViewUnblockRequestVendor from "./ViewUnblockRequestVendor";
import { getVendorListFormDetailById } from "../VendorNeedList/Action";

let loggedInUserDetail = userDetails();

const AssesmentForm = () => {
  const [activeTab, setActiveTab] = useState("1");
  const [questionComments, setQuestionComments] = useState({});
  const [selectedValues, setSelectedValues] = useState(null);
  const history = useHistory();
  const [questionErrors, setQuestionErrors] = useState({});
  const [questionDocument1, setQuestionDocument] = useState(null);
  const [showPopupForCorrection, setShowPopupForCorrection] = useState(false);
  const [showPopupForApprove, setShowPopupForApprove] = useState(false);
  const [showPopupForSubmit, setShowPopupForSubmit] = useState(false);
  const [isAssesmentRequired, setIsAssesmentRequired] = useState(false);
  const [showContentForm, setShowContentForm] = useState(false);
  const [showAssessment, setShowAssessment] = useState(false);
  const [remarkAccept, setRemarkAccept] = useState(false);
  const [showKysOneView, setsShowKysOneView] = useState(true);
  // const [centerLoading, setCenterLoading] = useState(false);

  const [applicationRegistrationStatus, setApplicationRegistrationStatus] =
    useState(null);
  const { reviewRequestResponseData } = useSelector(
    (state) => state?.ReviewRequestResponseData
  );
  const [viewDataFromSupplier, setViewDataFromSupplier] = useState(null);

  const [vendorKys1Data, setVendorKys1Data] = useState(null);

  const [
    IsSelfAssessmentSubmittedByRequester,
    setIsSelfAssessmentSubmittedByRequester,
  ] = useState(false);
  const [remarkApprove, setRemarkApprove] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false); // State to manage loading status
  const [remark, setRemark] = useState("");
  const [applicationStatus, setApplicationStatus] = useState([]);
  const [open, setOpen] = useState("1");

  const [selectedValuesForSupplier, setSelectedValuesForSupplier] = useState(
    {}
  );
  const {
    register,
    control,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const dashboardTabLock = useSelector(
    (state) => state.comman.dashboardTabLock
  );

  const urlParams = new URLSearchParams(window.location.search);
  const selfAssesmentId = urlParams.get("VendorRequirementRegistrationId");
  const nsaDetailAuditId = urlParams.get("nsaAuditDetailId");
  const EmployeeId = userDetails();
  const approveRequestForCorrectionCheckId =
    parseInt(EmployeeId?.EmployeeId) ===
    parseInt(viewDataFromSupplier?.VNFRequester);
  const dispatch = useDispatch();
  const getSelfAssesmentQuestions = (id) => {
    dispatch(fetchQuestionList(id));
  };
  const { selfAssesmentQuestion } = useSelector(
    (state) => state?.SelfAssesmentReducer
  );


  const toggle = (id) => {
    if (open === id) {
      setOpen();
    } else {
      setOpen(id);
    }
  };

  const onChangeRadio1 = (questionID, value) => {
    setSelectedValuesForSupplier((prevValues) => ({
      ...prevValues,
      [questionID]: value !== undefined ? value : null,
    }));
  };

  const getUsers = async (data) => {
    try {
      await dispatch(
        fetchReviewRequestResponseforApprover({
          VendorRequirementRegistrationId: data,
        })
      );
    } catch (error) {

    }
  };

  useEffect(() => {
    if (viewDataFromSupplier?.IsKYS1FormSubmitted == true || vendorKys1Data?.IsKYS1FormApproved == true) {
      setsShowKysOneView(true)
    }

    if (
      vendorKys1Data?.IsKYS1FormApproved == false && vendorKys1Data?.IsExceptionalSupplier == true &&
      vendorKys1Data?.KYS1Level1ApproverList?.includes(parseInt(loggedInUserDetail?.EmployeeId))
    ) {
      setsShowKysOneView(false)
    }
  }, [viewDataFromSupplier, vendorKys1Data]);

  useEffect(() => {
    getUsers(selfAssesmentId);
    getSelfAssesmentQuestions(selfAssesmentId);
    getApplicationStatusBarActivity();
  }, []);

  useEffect(() => {
    // Initialize questionComments with the initial values when the component mounts
    const initialComments = {};
    // Loop through the data array and set the initial values for supplier remarks
    selfAssesmentQuestion?.Data?.forEach((group) => {
      group.AssessmentQuestions.forEach((question) => {
        initialComments[question.AssessmentQuestionID] =
          question?.RequesterRemark || "";
      });
    });
    setQuestionComments(initialComments);
  }, [selfAssesmentQuestion?.Data]); // Empt

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get("VendorRequirementRegistrationId");
    if (id) {
      GetKYS1DetailByVendorRRId(id)
    }
  }, []);

  const GetKYS1DetailByVendorRRId = (id) => {
    axiosHelper.get(`${API.GetKYS1DetailByVendorRRId}?VendorRequirementRegistrationId=${id}`)
      .then(async (res) => {
        if (res?.data.IsSuccessful) {
          setVendorKys1Data(res?.data?.Data)
        }
      })
      .catch((error) => {

      });
  }

  const getApplicationStatusBarActivity = async () => {
    try {
      await getApplicationStepStatusBar(selfAssesmentId).then((res) => {
        setApplicationStatus(res?.Data[0]);
      });
    } catch (error) {

    }
  };
  const isAllQuestionsAnswered = () => {
    return selfAssesmentQuestion?.Data?.every((group) =>
      group?.AssessmentQuestions.every(
        (question) =>
          selectedValuesForSupplier?.hasOwnProperty(
            question?.AssessmentQuestionID
          ) || question?.RequesterReviewScore !== null
      )
    );
  };
  const handleBackButton = () => {
    setShowAssessment(false);
  };
  const handleGoToReview = () => {
    setShowContentForm(true);
  };
  const handleGoBackToQuestions = () => {
    setShowContentForm(false); // Function to set showSummary to false to go back to questions
  };

  const onPopupConfirmForCorrection = () => {
    setRemarkAccept(true);
    setShowPopupForCorrection(false);
  };
  const closePopUpForCorrection = () => {
    setShowPopupForCorrection(false);
  };
  const closePopUpForApprove = () => {
    setShowPopupForApprove(false);
  };
  const closePopUpForSubmit = () => {
    setShowPopupForSubmit(false);
  };
  const closePopUp = () => {
    // setShowPopup(false);
    setRemarkAccept(false);
    setRemarkApprove(false);
  };

  const popupInputData = (data) => {
    setRemark(data);
  };
  const handleRegisterUpload = (file, identifier) => {
    // Check if the file size is less than or equal to 5 MB (5 * 1024 * 1024 bytes)
    if (file.size <= 5 * 1024 * 1024) {
      const reader = new FileReader();
      reader.onload = (event) => {
        let base64String = event.target.result;

        // Remove the data type prefix
        base64String = base64String.replace(/^data:(.*?);base64,/, "");
        // Check if the file type is allowed (PDF, JPG, JPEG, 2PNG)
        const allowedFileTypes = [
          "application/pdf",
          "image/jpeg",
          "image/jpg",
          "image/png",
          "application/msword", // Allow .doc files
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // Allow .docx files
        ];
        const isTypeValid = allowedFileTypes.includes(file.type);

        if (!isTypeValid) {
          Toaster.error(
            "Unsupported file type. Please choose a file with one of the following formats: PDF, JPG, JPEG, PNG, DOC, or DOCX."
          );

          return;
        }
        // Pass file name, base64String, and fileType to setGstinFile
        const documentData = {
          fileName: file.name,
          base64String,
          fileType: file.type,
        };
        setQuestionDocument((prevDocuments) => ({
          ...prevDocuments,
          [identifier]: documentData,
        }));
      };
      reader.readAsDataURL(file);
    } else {
      Toaster.error("File size exceeds 5 MB. Please choose a smaller file.");
      // Handle the case where the file size exceeds 5 MB
    }
  };
  const handleSubmit = async () => {
    setSubmitLoading(true);

    const allQuestionIds = selfAssesmentQuestion?.Data?.flatMap((group) =>
      group.AssessmentQuestions.map((question) => ({
        assessmentQuestionID: question.AssessmentQuestionID,
        supplierScore: question.RequesterReviewScore,
        supplierRemark: question.RequesterRemark,
      }))
    );

    // Prepare submission data
    const submissionDetail = allQuestionIds.map((questionItem) => {
      const questionId = questionItem.assessmentQuestionID;
      const supplierScoreFromList = questionItem.supplierScore;
      const supplierRemarkableData = questionItem?.supplierRemark;
      const score =
        selectedValuesForSupplier?.hasOwnProperty(questionId) &&
          selectedValuesForSupplier[questionId] !== null
          ? selectedValuesForSupplier[questionId]
          : supplierScoreFromList !== null
            ? supplierScoreFromList
            : 0;

      const supplierReamrk = questionComments.hasOwnProperty(questionId)
        ? questionComments[questionId]
        : supplierRemarkableData;

      const documentDetails = questionDocument1?.[questionId] || null;
      const documentInfo = documentDetails
        ? { questionDocument: documentDetails }
        : {};
      return {
        questionId,
        Score: score,
        questionRemark: supplierReamrk || "",
        ...documentInfo,
      };
    });

    const userDetail = userDetails();
    const submissionData = {
      assessmentDetail: submissionDetail,
      vendorRequirementRegistrationId: parseInt(selfAssesmentId, 10),
      submittedBy: "Requester",
      isReviewRequested: false,
      qualityScore: parseInt(qualityScoreForGroupForRequestor),
      overallScore: parseInt(overAllPercentageForRequestor),
      SustainabilityScore: parseInt(sustainabilityScoreForGroupForRequestor),
      // remark: remark,
      requesterID: parseInt(userDetail?.EmployeeId),
    };
    // Handle submission (e.g., send data to server)
    setShowPopupForSubmit(false)
    dispatch(
      saveSelfAssesment(submissionData, (error, res) => {
        if (error) {
          Toaster.error(error?.data?.ErrorMessage);
        } else {
          // Handle successful submission
          if (res && res.IsSuccessful) {
            Toaster.success(res?.Data[0]?.Message);
            if (viewDataFromSupplier?.IsBlockedVendor) {
              history.push("/supplier-unblocking-request");
            } else {
              history.push("/vendor-need-list");
            }
          } else {
            // Handle unsuccessful submission
            console.error(
              "Error submitting self-assessment:",
              res?.data?.Message || "Unknown error occurred"
            );
            Toaster.error(res?.data?.Message || "Unknown error occurred");
          }
        }
        // Reset loading state
        setSubmitLoading(false);
      })
    );
  };

  const handleRequestForConfirmation = async (data, checkFlag) => {
    setSubmitLoading(true);
    const userDetail = userDetails();
    const reviewRequesterData = {
      isReviewRequested: data,
      remark: remark,
      requesterID: parseInt(userDetail?.EmployeeId),
      vendorRequirementRegistrationId: parseInt(selfAssesmentId, 10),
    };
    setRemarkApprove(false)
    setRemarkAccept(false)
    setShowPopupForApprove(false)
    dispatch(
      initiateRequestForCorrection(reviewRequesterData, (res) => {
        if (res) {
          Toaster.success(res?.data?.Data[0]?.Message);
          if (checkFlag == true) {
            history.push(`/view-supplier-need-form?VendorRequirementRegistrationId=${selfAssesmentId}`)
            // setSubmitLoading(false)
          } else {
            history.push("/vendor-need-list");
          }

        }

        setSubmitLoading(false);
        setRemark("");
        setRemarkAccept(false);
        setRemarkApprove(false);
      })
    );
  };
  const handleRequestForConrrection = async (data, checkFlag) => {
    if (!remark) {
      return;
    }
    setSubmitLoading(true);
    const userDetail = userDetails();
    const reviewRequesterData = {
      isReviewRequested: data,
      remark: remark,
      requesterID: parseInt(userDetail?.EmployeeId),
      vendorRequirementRegistrationId: parseInt(selfAssesmentId, 10),
    };
    setRemarkApprove(false)
    setRemarkAccept(false)
    setShowPopupForApprove(false)
    dispatch(
      initiateRequestForCorrection(reviewRequesterData, (res) => {
        if (res) {
          Toaster.success(res?.data?.Data[0]?.Message);
          if (viewDataFromSupplier?.IsBlockedVendor) {
            history.push("/supplier-unblocking-request");
          } else if (checkFlag == true) {

            history.push(`/view-supplier-need-form?VendorRequirementRegistrationId=${selfAssesmentId}`)

            // setSubmitLoading(false)

          } else {
            history.push("/vendor-need-list");
          }

        }

        setSubmitLoading(false);
        setRemark("");
        setRemarkAccept(false);
        setRemarkApprove(false);
      })
    );
  };

  const toggle1 = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const openViewDetailReport = queryParams.get("vdr");
    if (openViewDetailReport === "true") {
      toggle1("4")
    }
  }, [])

  const generateTableData = () => {
    // Calculate sum of scores for all groups
    let grandTotalScore = 0;
    let totalQuestionSelfAssesmentForm1 = 0;
    const tableData = selfAssesmentQuestion?.Data?.map((group) => {
      const sumOfScores = group?.AssessmentQuestions?.reduce(
        (accumulator, question) => {
          const assessmentQuestionID = question?.AssessmentQuestionID;
          // Check if selectedValues is not null and has the property assessmentQuestionID
          const selectedValueForQuestion = selectedValues?.hasOwnProperty(
            assessmentQuestionID
          )
            ? selectedValues[assessmentQuestionID]
            : null;

          // Use the selected value if available, otherwise use SupplierScore
          const score =
            selectedValueForQuestion !== null
              ? parseFloat(selectedValueForQuestion) // Parse the value to float
              : parseFloat(question?.SupplierScore || 0); // Parse the SupplierScore to float, default to 0 if null

          return accumulator + score;
        },
        0
      );
      grandTotalScore += sumOfScores;
      totalQuestionSelfAssesmentForm1 += group?.TotalScore || 0; // Accumulate total scores
      return {
        key: group?.CheckPointGroupID?.toString(),
        employeeCode: (
          <div className="fw-semibold">{group?.CheckPointGroupName}</div>
        ),
        employeeName: group?.TotalScore, // Assuming this is correct for the group
        position: sumOfScores, // Adjusted to include default scores
      };
    });

    // Add a static row for Grand Total at the end of the tableData
    tableData?.push({
      key: "grandTotal",
      employeeCode: <div className="fw-semibold">Grand Total</div>,
      position: <div className="hl-value-tbl">{grandTotalScore}</div>,
      employeeName: (
        <div className="hl-value-tbl">{totalQuestionSelfAssesmentForm1}</div>
      ),
    });

    return tableData;
  };

  const generateTableDataForRequestor = () => {
    // Calculate sum of scores for all groups
    let grandTotalScoreForReuestor = 0;
    let totalQuestionSelfAssesmentForm1 = 0;
    const tableData = selfAssesmentQuestion?.Data?.map((group) => {
      const sumOfScores = group?.AssessmentQuestions?.reduce(
        (accumulator, question) => {
          const assessmentQuestionID = question?.AssessmentQuestionID;
          // Check if selectedValues is not null and has the property assessmentQuestionID
          const selectedValueForQuestion =
            selectedValuesForSupplier?.hasOwnProperty(assessmentQuestionID)
              ? selectedValuesForSupplier[assessmentQuestionID]
              : null;

          // Use the selected value if available, otherwise use SupplierScore
          const score =
            selectedValueForQuestion !== null
              ? parseFloat(selectedValueForQuestion) // Parse the value to float
              : parseFloat(question?.RequesterReviewScore || 0); // Parse the SupplierScore to float, default to 0 if null

          return accumulator + score;
        },
        0
      );
      grandTotalScoreForReuestor += sumOfScores;
      totalQuestionSelfAssesmentForm1 += group?.TotalScore || 0; // Accumulate total scores
      return {
        key: group?.CheckPointGroupID?.toString(),
        employeeCode: (
          <div className="fw-semibold">{group?.CheckPointGroupName}</div>
        ),
        employeeName: group?.TotalScore, // Assuming this is correct for the group
        position1: sumOfScores, // Adjusted to include default scores
      };
    });

    // Add a static row for Grand Total at the end of the tableData
    tableData?.push({
      key: "grandTotal",
      employeeCode: <div className="fw-semibold">Grand Total</div>,
      position1: (
        <div className="hl-value-tbl">{grandTotalScoreForReuestor}</div>
      ),
      employeeName: (
        <div className="hl-value-tbl">{totalQuestionSelfAssesmentForm1}</div>
      ),
    });

    return tableData;
  };
  const columnsForRequestor = [
    {
      title: " ",
      dataIndex: "employeeCode",
      key: "employeeCode",
    },
    {
      title: "Total Score",
      dataIndex: "employeeName",
      key: "employeeName",
    },
    {
      title: "Score Achieved",
      dataIndex: "position1",
      key: "position1",
    },
  ];
  const dataDynamicForRequestor = generateTableDataForRequestor();
  const calculateQualityScoreForGroupForRequestor = () => {
    // Find the group with CheckPointGroupID as 1 from the assessment questions list
    const requestorGroup1 = selfAssesmentQuestion?.Data?.find(
      (group) => group?.CheckPointGroupID === 1
    );

    // Check if requestorGroup1 is undefined (no questions found)
    if (!requestorGroup1) {
      return 0; // Or any other default value you prefer
    }

    const sumOfScores = requestorGroup1?.AssessmentQuestions?.reduce(
      (accumulator, question) => {
        const assessmentQuestionID = question?.AssessmentQuestionID;
        // Check if selectedValuesForSupplier is not null and has the property assessmentQuestionID
        const selectedValueForQuestion =
          selectedValuesForSupplier?.hasOwnProperty(assessmentQuestionID)
            ? selectedValuesForSupplier[assessmentQuestionID]
            : null;
        // Use nullish coalescing to provide default values
        const score =
          selectedValueForQuestion !== null
            ? parseFloat(selectedValueForQuestion) // Parse the value to float
            : parseFloat(question?.RequesterReviewScore || 0); // Parse the RequesterReviewScore to float, default to 0 if null
        return accumulator + score;
      },
      0
    );
    const qualityScorePercentage =
      (sumOfScores / requestorGroup1?.TotalScore) * 100;
    return qualityScorePercentage;
  };

  const calculateSustainabilityScoreForGroupForRequestor = () => {
    // Find the group with CheckPointGroupID as 1 from the assessment questions list
    const requestorGroup1 = selfAssesmentQuestion?.Data?.find(
      (group) => group?.CheckPointGroupID === 4
    );

    // Check if requestorGroup1 is undefined (no questions found)
    if (!requestorGroup1) {
      return 0; // Or any other default value you prefer
    }

    const sumOfScores = requestorGroup1?.AssessmentQuestions?.reduce(
      (accumulator, question) => {
        const assessmentQuestionID = question?.AssessmentQuestionID;
        // Check if selectedValuesForSupplier is not null and has the property assessmentQuestionID
        const selectedValueForQuestion =
          selectedValuesForSupplier?.hasOwnProperty(assessmentQuestionID)
            ? selectedValuesForSupplier[assessmentQuestionID]
            : null;
        // Use nullish coalescing to provide default values
        const score =
          selectedValueForQuestion !== null
            ? parseFloat(selectedValueForQuestion) // Parse the value to float
            : parseFloat(question?.RequesterReviewScore || 0); // Parse the RequesterReviewScore to float, default to 0 if null
        return accumulator + score;
      },
      0
    );
    const qualityScorePercentage =
      (sumOfScores / requestorGroup1?.TotalScore) * 100;
    return qualityScorePercentage;
  };

  // Calculate the quality score percentage for group with CheckPointGroupID 1
  const qualityScoreForGroupForRequestor =
    calculateQualityScoreForGroupForRequestor();

  const sustainabilityScoreForGroupForRequestor =
    calculateSustainabilityScoreForGroupForRequestor();

  const overAllScoreAchievedForRequestor = dataDynamicForRequestor?.reduce(
    (accumulator, item) => {
      if (typeof item.position1 === "number") {
        return accumulator + item.position1;
      }
      // If item.position is not a number, return accumulator as is
      return accumulator;
    },
    0
  );
  const totalQuestionSelfAssesmentFormForRequestor =
    selfAssesmentQuestion?.Data?.reduce(
      (accumulator, group) => accumulator + group?.TotalScore,
      0
    );
  function calculaterOverAllPercentageForRequestor(scoreAchieved, totalScore) {
    if (totalScore === 0) {
      return 0; // To avoid division by zero error
    }
    return (scoreAchieved / totalScore) * 100;
  }
  const overAllPercentageForRequestor = calculaterOverAllPercentageForRequestor(
    overAllScoreAchievedForRequestor,
    totalQuestionSelfAssesmentFormForRequestor
  );
  // Dynamic table data
  const dataDynamic = generateTableData();
  const calculateQualityScoreForGroup1 = () => {
    // Find the group with CheckPointGroupID as 1 from the assessment questions list
    const group1 = selfAssesmentQuestion?.Data?.find(
      (group) => group?.CheckPointGroupID === 1
    );

    // Check if group1 is undefined (no questions found)
    if (!group1) {
      return 0; // Or any other default value you prefer
    }
    const sumOfScores = group1?.AssessmentQuestions?.reduce(
      (accumulator, question) => {
        const assessmentQuestionID = question?.AssessmentQuestionID;
        // Check if selectedValues is not null and has the property assessmentQuestionID
        const selectedValueForQuestion = selectedValues?.hasOwnProperty(
          assessmentQuestionID
        )
          ? selectedValues[assessmentQuestionID]
          : null;
        // Use nullish coalescing to provide default values
        const score =
          selectedValueForQuestion !== null
            ? parseFloat(selectedValueForQuestion) // Parse the value to float
            : parseFloat(question?.SupplierScore || 0); // Parse the SupplierScore to float, default to 0 if null
        return accumulator + score;
      },
      0
    );
    const qualityScorePercentage = (sumOfScores / group1?.TotalScore) * 100;
    return qualityScorePercentage;
  };

  // Calculate the quality score percentage for group with CheckPointGroupID 1
  const qualityScoreForGroup1 = calculateQualityScoreForGroup1();

  const calculateSustainabilityScoreForGroup1 = () => {
    // Find the group with CheckPointGroupID as 1 from the assessment questions list
    const group1 = selfAssesmentQuestion?.Data?.find(
      (group) => group?.CheckPointGroupID === 4
    );

    // Check if group1 is undefined (no questions found)
    if (!group1) {
      return 0; // Or any other default value you prefer
    }
    const sumOfScores = group1?.AssessmentQuestions?.reduce(
      (accumulator, question) => {
        const assessmentQuestionID = question?.AssessmentQuestionID;
        // Check if selectedValues is not null and has the property assessmentQuestionID
        const selectedValueForQuestion = selectedValues?.hasOwnProperty(
          assessmentQuestionID
        )
          ? selectedValues[assessmentQuestionID]
          : null;
        // Use nullish coalescing to provide default values
        const score =
          selectedValueForQuestion !== null
            ? parseFloat(selectedValueForQuestion) // Parse the value to float
            : parseFloat(question?.SupplierScore || 0); // Parse the SupplierScore to float, default to 0 if null
        return accumulator + score;
      },
      0
    );
    const qualityScorePercentage = (sumOfScores / group1?.TotalScore) * 100;
    return qualityScorePercentage;
  };

  // Calculate the quality score percentage for group with CheckPointGroupID 1
  const sustainabilityScoreForGroup1 = calculateSustainabilityScoreForGroup1();

  const overAllScoreAchieved = dataDynamic?.reduce((accumulator, item) => {
    if (typeof item.position === "number") {
      return accumulator + item.position;
    }
    // If item.position is not a number, return accumulator as is
    return accumulator;
  }, 0);
  const totalQuestionSelfAssesmentForm = selfAssesmentQuestion?.Data?.reduce(
    (accumulator, group) => accumulator + group?.TotalScore,
    0
  );
  function calculateQualityPercentage(scoreAchieved, totalScore) {
    if (totalScore === 0) {
      return 0; // To avoid division by zero error
    }
    return (scoreAchieved / totalScore) * 100;
  }
  const overAllPercentage = calculateQualityPercentage(
    overAllScoreAchieved,
    totalQuestionSelfAssesmentForm
  );

  const columns = [
    {
      title: " ",
      dataIndex: "employeeCode",
      key: "employeeCode",
    },
    {
      title: "Total Score",
      dataIndex: "employeeName",
      key: "employeeName",
    },
    {
      title: "Score Achieved",
      dataIndex: "position",
      key: "position",
    },
  ];
  const accordionItems = (checkPointGroupID) => {
    if (!selfAssesmentQuestion || !selfAssesmentQuestion.Data)
      return <div>No questions found.</div>;
    return selfAssesmentQuestion.Data.filter(
      (group) => group.CheckPointGroupID === checkPointGroupID
    ).flatMap((group) =>
      group.AssessmentQuestions.map((question, index) => (
        <div
          className="hl-que-items"
          key={`${group.CheckPointGroupID}_${index}`}
        >
          <div className="hl-que-body" accordionId={group?.CheckPointGroupName}>
            <Row>
              <Col
                md={
                  !(
                    applicationRegistrationStatus === 5 ||
                    applicationRegistrationStatus === 6 ||
                    applicationRegistrationStatus === 4
                  )
                    ? "6"
                    : "hl-left-acc-box"
                }
                className="hl-left-acc-box"
              >
                <div
                  className="hl-que-header"
                  targetId={group.CheckPointGroupName}
                >
                  {question.AssessmentQuestion}
                </div>
                <Form layout="vertical" className="max-w-5xl">
                  <Row gutter={[25, 0]}>
                    <Col md="10">
                      <FormGroup className="d-flex mt-1">
                        <div className="hl-form-radio-section d-flex hl-rating-color">
                          {[0, 1, 2, 3, 4].map((value) => (
                            <label key={value} className="hl-radio-label" title={question[`Option_${value}_Label`]}>
                              <Controller
                                control={control}
                                name={`qms[${question.AssessmentQuestionID}]`}
                                defaultValue=""
                                render={({ field }) => (
                                  <>
                                    <input
                                      {...field}
                                      type="radio"
                                      id={`qms_${question.AssessmentQuestionID}_${value}`}
                                      title={question[`Option_${value}_Label`]}
                                      value={index}
                                      disabled={true}
                                      checked={
                                        (selectedValues?.[
                                          question?.AssessmentQuestionID
                                        ] !== undefined &&
                                          selectedValues?.[
                                          question?.AssessmentQuestionID
                                          ] === value) ||
                                        (selectedValues?.[
                                          question?.AssessmentQuestionID
                                        ] === undefined &&
                                          question?.SupplierScore === value)
                                      }
                                    />
                                    <span
                                      htmlFor={`qms_${question.AssessmentQuestionID}_${value}`}
                                      className="ml-1"
                                    >
                                      {value}
                                    </span>
                                  </>
                                )}
                              />
                            </label>
                          ))}
                        </div>
                      </FormGroup>
                      <FormGroup>
                        <div className="input-section">
                          <label>Add Comment (If Any)</label>
                          <div className="hl-form-comment-section">
                            <textarea
                              {...register(
                                `SupplierRemark[${question.AssessmentQuestionID}]`,
                                {
                                  required: false,
                                  maxLength: 250, // Adding maxLength validation
                                }
                              )}
                              name={`SupplierRemark[${question.AssessmentQuestionID}]`}
                              value={question.SupplierRemark || ""}
                              placeholder="Enter"
                              className="withBorder mb-0 form-control w-70"
                              disabled={true}
                            />
                            {errors &&
                              errors[
                              `SupplierRemark[${question.AssessmentQuestionID}]`
                              ] &&
                              errors[
                                `SupplierRemark[${question.AssessmentQuestionID}]`
                              ].type === "maxLength" && ( // Checking if the error type is maxLength
                                <span className="error-message">
                                  Maximum length exceeded (250 characters).
                                </span>
                              )}

                            <FileUploadSelfAssesment
                              control={control}
                              name={`questionDocumentpppp[${question.AssessmentQuestionID}]`}
                              label="Upload Register Certificate"
                              uploadWrapClass="hl-file-left"
                              downloadBtn="hl-mb-0"
                              uploadClass="mt-2 hl-mb-0"
                              disabled={true}
                              uploadedFile={
                                question?.SupplierQuestionDocumentPath
                              }
                              setUplaodedFile={
                                question?.SupplierQuestionDocumentPath
                              }
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>
                </Form>
              </Col>
              {!(
                applicationRegistrationStatus === 5 ||
                applicationRegistrationStatus === 6 ||
                applicationRegistrationStatus === 4
              ) && (
                  <Col md="6" className="hl-right-acc-box">
                    <div
                      className="hl-que-header"
                      targetId={group.CheckPointGroupName}
                    >
                      {question.AssessmentQuestion}
                    </div>
                    <Form layout="vertical" className="max-w-5xl">
                      <Row gutter={[25, 0]}>
                        <Col md="10">
                          <FormGroup className="d-flex mt-1">
                            <div className="hl-form-radio-section d-flex hl-rating-color">
                              {[0, 1, 2, 3, 4].map((value) => (
                                <label key={value} className="hl-radio-label" title={question[`Option_${value}_Label`]}>
                                  <Controller
                                    control={control}
                                    name={`qms[${question.AssessmentQuestionID}]`}
                                    defaultValue=""
                                    render={({ field }) => (
                                      <>
                                        <input
                                          {...field}
                                          type="radio"
                                          id={`qms_${question.AssessmentQuestionID}_${value}`}
                                          title={
                                            question[`Option_${value}_Label`]
                                          }
                                          // value={index}
                                          value={
                                            selectedValuesForSupplier[
                                            question?.AssessmentQuestionID
                                            ] ?? question?.RequesterReviewScore
                                          }
                                          // disabled={true}
                                          disabled={
                                            applicationRegistrationStatus !== 5 &&
                                            applicationRegistrationStatus !== 6 &&
                                            applicationRegistrationStatus !== 7
                                          }
                                          checked={
                                            (selectedValuesForSupplier?.[
                                              question?.AssessmentQuestionID
                                            ] !== undefined &&
                                              selectedValuesForSupplier?.[
                                              question?.AssessmentQuestionID
                                              ] === value) ||
                                            (selectedValuesForSupplier?.[
                                              question?.AssessmentQuestionID
                                            ] === undefined &&
                                              question?.RequesterReviewScore ===
                                              value)
                                          }
                                          onChange={(e) => {
                                            field.onChange(e);
                                            onChangeRadio1(
                                              question.AssessmentQuestionID,
                                              value // Use value instead of index
                                            );
                                          }}
                                        />
                                        <span
                                          htmlFor={`qms_${question.AssessmentQuestionID}_${value}`}
                                          className="ml-1"
                                        >
                                          {value}
                                        </span>
                                      </>
                                    )}
                                  />
                                </label>
                              ))}
                            </div>
                          </FormGroup>
                          <FormGroup>
                            <div
                              className="input-section"
                              key={question.AssessmentQuestionID}
                            >
                              <label>Add Comment (If Any)</label>
                              <div className="hl-form-comment-section">
                                {/* <textarea
                                  {...register(
                                    `RequestorRemark[${question.AssessmentQuestionID}]`
                                  )}
                                  name={`RequestorRemark[${question.AssessmentQuestionID}]`}
                                  value={
                                    questionComments[
                                    question?.AssessmentQuestionID
                                    ] || ""
                                  }
                                  onChange={(e) => {
                                    const userInput = e.target.value;
                                    setQuestionComments((prevComments) => ({
                                      ...prevComments,
                                      [question?.AssessmentQuestionID]: userInput,
                                    }));
                                    // Check if the length exceeds 250 characters and set the error state accordingly
                                    if (userInput.length > 250) {
                                      setQuestionErrors((prevErrors) => ({
                                        ...prevErrors,
                                        [question?.AssessmentQuestionID]: true,
                                      }));
                                    } else {
                                      setQuestionErrors((prevErrors) => ({
                                        ...prevErrors,
                                        [question?.AssessmentQuestionID]: false,
                                      }));
                                    }
                                  }}
                                  placeholder="Enter"
                                  className={`withBorder mb-0 form-control w-70 ${questionErrors[question?.AssessmentQuestionID]
                                    ? "error"
                                    : ""
                                    }`}
                                  disabled={
                                    applicationRegistrationStatus !== 5 &&
                                    applicationRegistrationStatus !== 6 &&
                                    applicationRegistrationStatus !== 7
                                  }
                                />
                                {questionErrors[
                                  question?.AssessmentQuestionID
                                ] && (
                                    <span className="error-message">
                                      Maximum length exceeded (250 characters).
                                    </span>
                                  )} */}
                                <textarea
                                  {...register(`RequestorRemark[${question.AssessmentQuestionID}]`)}
                                  name={`RequestorRemark[${question.AssessmentQuestionID}]`}
                                  value={questionComments[question?.AssessmentQuestionID] || ""}
                                  onChange={(e) => {
                                    const userInput = e.target.value;
                                    const specialCharPattern = /^[!@#$%^&*(),.?":{}|<>]|[!@#$%^&*(),.?":{}|<>]$/;

                                    setQuestionComments((prevComments) => ({
                                      ...prevComments,
                                      [question?.AssessmentQuestionID]: userInput,
                                    }));

                                    // Check if the length exceeds 250 characters
                                    if (userInput.length > 250) {
                                      setQuestionErrors((prevErrors) => ({
                                        ...prevErrors,
                                        [question?.AssessmentQuestionID]: "Maximum length exceeded (250 characters).",
                                      }));
                                    }
                                    // Check if the input starts or ends with a special character
                                    else if (specialCharPattern.test(userInput)) {
                                      setQuestionErrors((prevErrors) => ({
                                        ...prevErrors,
                                        [question?.AssessmentQuestionID]: "Input cannot start or end with a special character.",
                                      }));
                                    }
                                    // No error
                                    else {
                                      setQuestionErrors((prevErrors) => ({
                                        ...prevErrors,
                                        [question?.AssessmentQuestionID]: false,
                                      }));
                                    }
                                  }}
                                  placeholder="Enter"
                                  className={`withBorder mb-0 form-control w-70 ${questionErrors[question?.AssessmentQuestionID] ? "error" : ""}`}
                                  disabled={
                                    applicationRegistrationStatus !== 5 &&
                                    applicationRegistrationStatus !== 6 &&
                                    applicationRegistrationStatus !== 7
                                  }
                                />
                                {questionErrors[question?.AssessmentQuestionID] && (
                                  <span className="error-message">
                                    {questionErrors[question?.AssessmentQuestionID]}
                                  </span>
                                )}
                                {/* <FileUploadSelfAssesmentRequestor
                                  control={control}
                                  name={`questionDocument[${question.AssessmentQuestionID}]`}
                                  label="Upload Register Certificate"
                                  uploadWrapClass="hl-file-left"
                                  uploadClass="mt-2 hl-mb-0 ml-4"
                                  disabled={
                                    applicationRegistrationStatus !== 5 &&
                                    applicationRegistrationStatus !== 6 &&
                                    applicationRegistrationStatus !== 7
                                  }
                                  uploadedFile={
                                    question?.RequesterQuestionDocumentPath
                                  }
                                  setUplaodedFile={
                                    question?.RequesterQuestionDocumentPath
                                  }
                                  handleRegisterUpload={(file) => {
                                    handleRegisterUpload(
                                      file,
                                      question?.AssessmentQuestionID
                                    );
                                  }}
                                  allowedFileTypes={[
                                    "application/pdf",
                                    "image/jpeg",
                                    "image/jpg",
                                    "image/png",
                                    "application/msword", // Allow .doc files
                                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // Allow .docx files
                                  ]}
                                /> */}
                                <FileUploadSelfAssesmentRequestor
                                  control={control}
                                  name={`questionDocument[${question.AssessmentQuestionID}]`}
                                  label="Upload Register Certificate"
                                  uploadWrapClass="hl-file-left"
                                  uploadClass="mt-2 hl-mb-0 ml-4"
                                  disabled={
                                    applicationRegistrationStatus !== 5 &&
                                    applicationRegistrationStatus !== 6 &&
                                    applicationRegistrationStatus !== 7
                                  }
                                  uploadedFile={question?.RequesterQuestionDocumentPath}
                                  setUplaodedFile={question?.RequesterQuestionDocumentPath}
                                  handleRegisterUpload={(file) => {
                                    handleRegisterUpload(file, question?.AssessmentQuestionID);
                                  }}
                                  allowedFileTypes={[
                                    "application/pdf",
                                    "image/jpeg",
                                    "image/jpg",
                                    "image/png",
                                    "application/msword",
                                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                  ]}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>
                    </Form>
                  </Col>
                )}
            </Row>
          </div>
        </div>
      ))
    );
  };
  return (
    <>
      {submitLoading &&
        <LoaderCustom customClass="simulation-Loader hl-loader-fixed" />
      }
      <Row className={`filter-row-large`}>
        <Col md="12" className="mb-3 d-flex justify-content-end">
          <button
            type="button"
            className={"apply mt-1"}
            onClick={() => window.history.back()}
          >
            <div className={"back-icon"}></div>Back
          </button>
        </Col>
      </Row>
      {viewDataFromSupplier?.IsBlockedVendor ? (
        <Row className="Assessment-setup-section pt-2">
          <Col>
            <div
              className={`Assessment-setup-box ${applicationStatus?.NeedForm === 1
                ? "hl-step-active"
                : applicationStatus?.NeedForm === 2
                  ? "hl-step-complete "
                  : ""
                }`}
            >
              <span className="mr-auto">
                <strong>1</strong>
              </span>
              <h4 className="text-left">
                Unblocking
                <p className="hl-timeline-date">
                  {applicationStatus?.NeedForm_StartDate ||
                    applicationStatus?.NeedForm_EndDate ? (
                    <p className="hl-timeline-date">
                      {applicationStatus?.NeedForm_StartDate}
                      {applicationStatus?.NeedForm_StartDate &&
                        applicationStatus?.NeedForm_EndDate
                        ? " - "
                        : ""}
                      {applicationStatus?.NeedForm_EndDate}
                    </p>
                  ) : null}
                </p>
              </h4>
            </div>
          </Col>
          <Col>
            <div
              className={`Assessment-setup-box ${applicationStatus?.NeedApproval === 1
                ? "hl-step-active"
                : applicationStatus?.NeedApproval === 2
                  ? "hl-step-complete"
                  : applicationStatus?.NeedApproval === 3
                    ? "hl-step-red"
                    : ""
                }`}
            >
              <span className="mr-auto">
                <strong>2</strong>
              </span>
              <h4 className="text-left">
                Unblocking Approval
                <p className="hl-timeline-date">
                  {applicationStatus?.NeedApproval_StartDate ||
                    applicationStatus?.NeedApproval_EndDate ? (
                    <p className="hl-timeline-date">
                      {applicationStatus?.NeedApproval_StartDate}
                      {applicationStatus?.NeedApproval_StartDate &&
                        applicationStatus?.NeedApproval_EndDate
                        ? " - "
                        : ""}
                      {applicationStatus?.NeedApproval_EndDate}
                    </p>
                  ) : null}
                </p>
              </h4>
            </div>
          </Col>
          {/* <Col>
          <div
            className={`Assessment-setup-box ${applicationStatus?.ContractSigned === 1
              ? "hl-step-active"
              : applicationStatus?.ContractSigned === 2
                ? "hl-step-complete"
                : ""
              }`}
          >
            <span className="mr-auto">
              <strong>3</strong>
            </span>
            <h4 className="text-left">Contract Signed<p className="hl-timeline-date">
              {applicationStatus?.ContractSigned_StartDate || applicationStatus?.ContractSigned_EndDate ? (
                <p className="hl-timeline-date">
                  {applicationStatus?.ContractSigned_StartDate}
                  {applicationStatus?.ContractSigned_StartDate && applicationStatus?.ContractSigned_EndDate ? ' - ' : ''}
                  {applicationStatus?.ContractSigned_EndDate}
                </p>
              ) : null}
            </p></h4>
          </div>
        </Col> */}
          <Col>
            <div
              className={`Assessment-setup-box ${applicationStatus?.Registration_kys1 === 1
                ? "hl-step-active"
                : applicationStatus?.Registration_kys1 === 2
                  ? "hl-step-complete"
                  : applicationStatus?.Registration_kys1 === 3
                    ? "hl-step-red"
                    : ""
                }`}
            >
              <span className="mr-auto">
                <strong>3</strong>
              </span>
              <h4 className="text-left">
                KYS 1
                <p className="hl-timeline-date">
                  {applicationStatus?.Registration_kys1StartDate ||
                    applicationStatus?.Registration_kys1EndDate ? (
                    <p className="hl-timeline-date">
                      {applicationStatus?.Registration_kys1StartDate}
                      {applicationStatus?.Registration_kys1StartDate &&
                        applicationStatus?.Registration_kys1EndDate
                        ? " - "
                        : ""}
                      {applicationStatus?.Registration_kys1EndDate}
                    </p>
                  ) : null}
                </p>
              </h4>
            </div>
          </Col>
          <Col>
            <div
              className={`Assessment-setup-box ${applicationStatus?.NSAAudit === 1
                ? "hl-step-active"
                : applicationStatus?.NSAAudit === 2
                  ? "hl-step-complete"
                  : applicationStatus?.NSAAudit === 3
                    ? "hl-step-red"
                    : ""
                }`}
            >
              <span className="mr-auto">
                <strong>4</strong>
              </span>
              <h4 className="text-left">
                NSA Audit
                <p className="hl-timeline-date">
                  {applicationStatus?.NSAStartDate ||
                    applicationStatus?.NSAEndDate ? (
                    <p className="hl-timeline-date">
                      {applicationStatus?.NSAStartDate}
                      {applicationStatus?.NSAStartDate &&
                        applicationStatus?.NSAEndDate
                        ? " - "
                        : ""}
                      {applicationStatus?.NSAEndDate}
                    </p>
                  ) : null}
                </p>
              </h4>
            </div>
          </Col>
          <Col>
            <div
              className={`Assessment-setup-box ${applicationStatus?.KYS2 === 1
                ? "hl-step-active"
                : applicationStatus?.KYS2 === 2
                  ? "hl-step-complete"
                  : applicationStatus?.KYS2 === 3
                    ? "hl-step-red"
                    : ""
                }`}
            >
              <span className="mr-auto">
                <strong>5</strong>
              </span>
              <h4 className="text-left">
                KYS 2
                <p className="hl-timeline-date">
                  {applicationStatus?.KYS2Start_Date ||
                    applicationStatus?.KYS2End_Date ? (
                    <p className="hl-timeline-date">
                      {applicationStatus?.KYS2Start_Date}
                      {applicationStatus?.KYS2Start_Date &&
                        applicationStatus?.KYS2End_Date
                        ? " - "
                        : ""}
                      {applicationStatus?.KYS2End_Date}
                    </p>
                  ) : null}
                </p>
              </h4>
            </div>
          </Col>
          <Col>
            <div
              className={`Assessment-setup-box ${applicationStatus?.RegistrationComplete === 1
                ? "hl-step-active"
                : applicationStatus?.RegistrationComplete === 2
                  ? "hl-step-complete"
                  : applicationStatus?.RegistrationComplete === 3
                    ? "hl-step-red"
                    : ""
                }`}
            >
              <span className="mr-auto">
                <strong>6</strong>
              </span>
              <h4 className="text-left">
                Unblocking Completed
                <p className="hl-timeline-date">
                  {applicationStatus?.RegistrationStartedStartDate ||
                    applicationStatus?.RegistrationStartedEndDate ? (
                    <p className="hl-timeline-date">
                      {applicationStatus?.RegistrationStartedStartDate}
                      {applicationStatus?.RegistrationStartedStartDate &&
                        applicationStatus?.RegistrationStartedEndDate
                        ? " - "
                        : ""}
                      {applicationStatus?.RegistrationStartedEndDate}
                    </p>
                  ) : null}
                </p>
              </h4>
            </div>
          </Col>
        </Row>
      ) : (
        <Row className="Assessment-setup-section pt-2">
          <Col>
            <div
              className={`Assessment-setup-box ${applicationStatus?.NeedForm === 1
                ? "hl-step-active"
                : applicationStatus?.NeedForm === 2
                  ? "hl-step-complete"
                  : applicationStatus?.NeedForm === 3
                    ? "hl-step-red"
                    : ""
                }`}
            >
              <span className="mr-auto">
                <strong>1</strong>
              </span>
              <h4 className="text-left">
                {viewDataFromSupplier?.IsBlockedVendor ? "Unblocking Form" : "Supplier Need Form"}
                <p className="hl-timeline-date">
                  {applicationStatus?.NeedForm_StartDate ||
                    applicationStatus?.NeedForm_EndDate ? (
                    <p className="hl-timeline-date">
                      {applicationStatus?.NeedForm_StartDate}
                      {applicationStatus?.NeedForm_StartDate &&
                        applicationStatus?.NeedForm_EndDate
                        ? " - "
                        : ""}
                      {applicationStatus?.NeedForm_EndDate}
                    </p>
                  ) : null}
                </p>
              </h4>
            </div>
          </Col>
          <Col>
            <div
              className={`Assessment-setup-box ${applicationStatus?.NeedApproval === 1
                ? "hl-step-active"
                : applicationStatus?.NeedApproval === 2
                  ? "hl-step-complete"
                  : applicationStatus?.NeedApproval === 3
                    ? "hl-step-red"
                    : ""
                }`}
            >
              <span className="mr-auto">
                <strong>2</strong>
              </span>
              <h4 className="text-left">
                {viewDataFromSupplier?.IsBlockedVendor ? 'Unblocking Approval' : 'Supplier Need Form Approval'}
                <p className="hl-timeline-date">
                  {applicationStatus?.NeedApproval_StartDate ||
                    applicationStatus?.NeedApproval_EndDate ? (
                    <p className="hl-timeline-date">
                      {applicationStatus?.NeedApproval_StartDate}
                      {applicationStatus?.NeedApproval_StartDate &&
                        applicationStatus?.NeedApproval_EndDate
                        ? " - "
                        : ""}
                      {applicationStatus?.NeedApproval_EndDate}
                    </p>
                  ) : null}
                </p>
              </h4>
            </div>
          </Col>
          {/* <Col>
          <div
            className={`Assessment-setup-box ${applicationStatus?.ContractSigned === 1
              ? "hl-step-active"
              : applicationStatus?.ContractSigned === 2
                ? "hl-step-complete"
                : ""
              }`}
          >
            <span className="mr-auto">
              <strong>3</strong>
            </span>
            <h4 className="text-left">Contract Signed<p className="hl-timeline-date">
              {applicationStatus?.ContractSigned_StartDate || applicationStatus?.ContractSigned_EndDate ? (
                <p className="hl-timeline-date">
                  {applicationStatus?.ContractSigned_StartDate}
                  {applicationStatus?.ContractSigned_StartDate && applicationStatus?.ContractSigned_EndDate ? ' - ' : ''}
                  {applicationStatus?.ContractSigned_EndDate}
                </p>
              ) : null}
            </p></h4>
          </div>
        </Col> */}
          <Col>
            <div
              className={`Assessment-setup-box ${applicationStatus?.Registration_kys1 === 1
                ? "hl-step-active"
                : applicationStatus?.Registration_kys1 === 2
                  ? "hl-step-complete"
                  : applicationStatus?.Registration_kys1 === 3
                    ? "hl-step-red"
                    : ""
                }`}
            >
              <span className="mr-auto">
                <strong>3</strong>
              </span>
              <h4 className="text-left">
                KYS 1
                <p className="hl-timeline-date">
                  {applicationStatus?.Registration_kys1StartDate ||
                    applicationStatus?.Registration_kys1EndDate ? (
                    <p className="hl-timeline-date">
                      {applicationStatus?.Registration_kys1StartDate}
                      {applicationStatus?.Registration_kys1StartDate &&
                        applicationStatus?.Registration_kys1EndDate
                        ? " - "
                        : ""}
                      {applicationStatus?.Registration_kys1EndDate}
                    </p>
                  ) : null}
                </p>
              </h4>
            </div>
          </Col>
          <Col>
            <div
              className={`Assessment-setup-box ${applicationStatus?.NSAAudit === 1
                ? "hl-step-active"
                : applicationStatus?.NSAAudit === 2
                  ? "hl-step-complete"
                  : applicationStatus?.NSAAudit === 3
                    ? "hl-step-red"
                    : ""
                }`}
            >
              <span className="mr-auto">
                <strong>4</strong>
              </span>
              <h4 className="text-left">
                NSA Audit
                <p className="hl-timeline-date">
                  {applicationStatus?.NSAStartDate ||
                    applicationStatus?.NSAEndDate ? (
                    <p className="hl-timeline-date">
                      {applicationStatus?.NSAStartDate}
                      {applicationStatus?.NSAStartDate &&
                        applicationStatus?.NSAEndDate
                        ? " - "
                        : ""}
                      {applicationStatus?.NSAEndDate}
                    </p>
                  ) : null}
                </p>
              </h4>
            </div>
          </Col>
          <Col>
            <div
              className={`Assessment-setup-box ${applicationStatus?.KYS2 === 1
                ? "hl-step-active"
                : applicationStatus?.KYS2 === 2
                  ? "hl-step-complete"
                  : applicationStatus?.KYS2 === 3
                    ? "hl-step-red"
                    : ""
                }`}
            >
              <span className="mr-auto">
                <strong>5</strong>
              </span>
              <h4 className="text-left">
                KYS 2
                <p className="hl-timeline-date">
                  {applicationStatus?.KYS2Start_Date ||
                    applicationStatus?.KYS2End_Date ? (
                    <p className="hl-timeline-date">
                      {applicationStatus?.KYS2Start_Date}
                      {applicationStatus?.KYS2Start_Date &&
                        applicationStatus?.KYS2End_Date
                        ? " - "
                        : ""}
                      {applicationStatus?.KYS2End_Date}
                    </p>
                  ) : null}
                </p>
              </h4>
            </div>
          </Col>
          <Col>
            <div
              className={`Assessment-setup-box ${applicationStatus?.RegistrationComplete === 1
                ? "hl-step-active"
                : applicationStatus?.RegistrationComplete === 2
                  ? "hl-step-complete"
                  : applicationStatus?.RegistrationComplete === 3
                    ? "hl-step-red"
                    : ""
                }`}
            >
              <span className="mr-auto">
                <strong>6</strong>
              </span>
              <h4 className="text-left">
                Registration Completed
                <p className="hl-timeline-date">
                  {applicationStatus?.RegistrationStartedStartDate ||
                    applicationStatus?.RegistrationStartedEndDate ? (
                    <p className="hl-timeline-date">
                      {applicationStatus?.RegistrationStartedStartDate}
                      {applicationStatus?.RegistrationStartedStartDate &&
                        applicationStatus?.RegistrationStartedEndDate
                        ? " - "
                        : ""}
                      {applicationStatus?.RegistrationStartedEndDate}
                    </p>
                  ) : null}
                </p>
              </h4>
            </div>
          </Col>
        </Row>
      )}

      <div className="d-flex justify-content-around hl-blue-strip mt-3">
        <div>
          <h3>
            <span class="font-normal">Application No: -</span>{" "}
            {viewDataFromSupplier?.ApplicationNo
              ? viewDataFromSupplier?.ApplicationNo
              : ""}
          </h3>
        </div>
        <div>
          <h3>
            <span class="font-normal">Supplier Name: -</span>{" "}
            {viewDataFromSupplier?.VendorName
              ? viewDataFromSupplier?.VendorName
              : ""}
          </h3>
        </div>
        <div>
          <h3>
            <span class="font-normal">Category: -</span>{" "}
            {viewDataFromSupplier?.CategoryName
              ? viewDataFromSupplier?.CategoryName
              : ""}
          </h3>
        </div>
        {viewDataFromSupplier?.Vendorcode ? (
          <div>
            <h3>
              <span class="font-normal">Supplier Code: -</span>{" "}
              {viewDataFromSupplier?.Vendorcode
                ? viewDataFromSupplier?.Vendorcode
                : ""}
            </h3>
          </div>
        ) : (
          ""
        )}

      </div>

      <div className="assessment-tabs hl-self-assessment-wrap mt-5">
        <Nav tabs className="subtabs mt-0 p-relative">
          {dashboardTabLock && (
            <div className="disabled-overflow min-width"></div>
          )}
          <NavItem>
            <NavLink
              id={`dashboard_Masters_Pending_Approval`}
              className={classnames({ active: activeTab === "1" })}
              onClick={() => {
                toggle1("1");
              }}
            >

              {viewDataFromSupplier?.IsBlockedVendor ? "Unblocking Form" : "Supplier Need Form"}            </NavLink>
          </NavItem>
          {isAssesmentRequired && (
            <NavItem>
              <NavLink
                id={`dashboard_Masters_Awaiting_Approval`}
                className={classnames({ active: activeTab === "2" })}
                onClick={() => {
                  toggle1("2");
                }}
              >
                Assessment Form
              </NavLink>
            </NavItem>
          )}
          {((isAssesmentRequired && IsSelfAssessmentSubmittedByRequester) ||
            !isAssesmentRequired) && (
              <NavItem>
                <NavLink
                  id={`dashboard_Masters_Awaiting_Approval`}
                  className={classnames({ active: activeTab === "3" })}
                  onClick={() => {
                    toggle1("3");
                  }}
                >
                  {viewDataFromSupplier?.IsBlockedVendor ? 'Unblocking Approval' : 'Supplier Need Form Approval'}
                </NavLink>
              </NavItem>
            )}
          {/* {reviewRequestResponseData &&
            reviewRequestResponseData?.Data?.RequestReviews?.length > 0 && (
              <NavItem>
                <NavLink
                  id={`dashboard_Masters_Awaiting_Approval`}
                  className={classnames({ active: activeTab === "5" })}
                  onClick={() => {
                    toggle1("5");
                  }}
                >
                  Review Request{" "}
                  <span>
                    {reviewRequestResponseData?.Data?.RequestReviewCount}
                  </span>
                </NavLink>
              </NavItem>
            )} */}
          {viewDataFromSupplier?.IsNSARequired && nsaDetailAuditId && (
            <NavItem>
              <NavLink
                id={`dashboard_Masters_Awaiting_Approval`}
                className={classnames({ active: activeTab === "4" })}
                onClick={() => {
                  toggle1("4");
                }}
              >
                NSA
              </NavLink>
            </NavItem>)
          }
          {
            viewDataFromSupplier?.IsKYS1TabVisible && (
              <NavItem>
                <NavLink
                  id={`dashboard_Masters_Awaiting_Approval`}
                  className={classnames({ active: activeTab === "6" })}
                  onClick={() => {
                    toggle1("6");
                  }}
                >
                  KYS 1
                </NavLink>
              </NavItem>
            )
          }
          {
            viewDataFromSupplier?.IsKYS2TabVisible && (
              <NavItem>
                <NavLink
                  id={`dashboard_Masters_Awaiting_Approval`}
                  className={classnames({ active: activeTab === "7" })}
                  onClick={() => {
                    toggle1("7");
                  }}
                >
                  KYS 2
                </NavLink>
              </NavItem>
            )
          }
          {
            viewDataFromSupplier?.IsKYS2ApprovalTabVisible && (
              <NavItem>
                <NavLink
                  id={`dashboard_Masters_Awaiting_Approval`}
                  className={classnames({ active: activeTab === "9" })}
                  onClick={() => {
                    toggle1("9");
                  }}
                >
                  KYS 2 Approval
                </NavLink>
              </NavItem>
            )
          }
          {
            viewDataFromSupplier?.IsExceptionalFlowTrackingTabVisible && (
              <NavItem>
                <NavLink
                  id={`dashboard_Masters_Awaiting_Approval`}
                  className={classnames({ active: activeTab === "8" })}
                  onClick={() => {
                    toggle1("8");
                  }}
                >
                  Exceptional Approval List
                </NavLink>
              </NavItem>
            )
          }
        </Nav>
        <TabContent activeTab={activeTab}>
          {activeTab === "1" && (
            <TabPane tabId="1" className="hl-vendor-need-view">
              {viewDataFromSupplier?.IsBlockedVendor ? (
                <ViewUnblockRequestVendor />
              ) : (

                <ViewVendorSupplierNeedForm
                  // setCenterLoading={setCenterLoading}
                  setApplicationRegistrationStatus={
                    setApplicationRegistrationStatus
                  }
                  setIsAssesmentRequired={setIsAssesmentRequired}
                  setIsSelfAssessmentSubmittedByRequester={
                    setIsSelfAssessmentSubmittedByRequester
                  }
                  setViewDataFromSupplier={setViewDataFromSupplier}
                />
              )}
            </TabPane>
          )}
          {activeTab === "2" && isAssesmentRequired && (
            <TabPane tabId="2">
              {applicationRegistrationStatus === 28 ? (
                <div className="hl-pending-text">
                  <Alert color="warning">
                    <h2>
                      <span class="font-16 d-flex">
                        <i
                          class="fa fa-info-circle mr-2"
                          aria-hidden="true"
                        ></i>{" "}
                        <span>
                          Self-assessment pending from the supplier's end.
                        </span>
                      </span>
                    </h2>
                  </Alert>
                </div>
              ) : !showAssessment ? (
                <AssesmentTab setShowAssessment={setShowAssessment} setShowContentForm={setShowContentForm} viewDataFromSupplier={viewDataFromSupplier} />
              ) : (
                !showContentForm && (
                  <UncontrolledAccordion
                    open={open}
                    toggle={toggle}
                    className="pb-2"
                    defaultOpen={["1"]}
                    stayOpen
                  >
                    <Row
                      noGutters
                      className="mb-3 hl-fixed-header hl-fixed-header-n20"
                    >
                      <Col
                        md={
                          !(
                            applicationRegistrationStatus === 5 ||
                            applicationRegistrationStatus === 6 ||
                            applicationRegistrationStatus === 4
                          )
                            ? "6"
                            : ""
                        }
                      >
                        <h3 className="hl-tbl-heading pl-5">
                          Supplier Self Assessment
                        </h3>
                      </Col>

                      {!(
                        applicationRegistrationStatus === 5 ||
                        applicationRegistrationStatus === 6 ||
                        applicationRegistrationStatus === 4
                      ) ? (
                        <Col md="6">
                          <h3 className="hl-tbl-heading pl-5">
                            Requestor Assessment
                          </h3>
                        </Col>
                      ) : null}
                    </Row>
                    {selfAssesmentQuestion?.Data.map((item, index) => (
                      <AccordionItem key={index}>
                        <AccordionHeader targetId={item.CheckPointGroupName}>
                          <div className="header-title">
                            <h5>{item.CheckPointGroupName}:</h5>
                          </div>
                        </AccordionHeader>
                        <AccordionBody accordionId={item.CheckPointGroupName}>
                          {/* Render the appropriate component based on the CheckPointGroupName */}
                          {accordionItems(item.CheckPointGroupID)}
                        </AccordionBody>
                      </AccordionItem>
                    ))}
                  </UncontrolledAccordion>
                )
              )}
            </TabPane>
          )}

          {activeTab === "3" && (
            <TabPane tabId="3" className="hl-vendor-need-view">
              {((isAssesmentRequired && IsSelfAssessmentSubmittedByRequester) ||
                !isAssesmentRequired) && (
                  <VendorNeedApprovalHavells
                    selfAssesmentId={selfAssesmentId}
                    viewDataFromSupplier={viewDataFromSupplier}
                  />
                )}
            </TabPane>
          )}
          {activeTab === "4" && (
            <TabPane tabId="4" className="hl-vendor-need-view">
              <Nsa viewDataFromSupplier={viewDataFromSupplier} />
            </TabPane>
          )}
          {activeTab === "5" && (
            <TabPane tabId="5" className="hl-vendor-need-view">
              <NeedFormReviewRequest
                reviewRequestResponseData={reviewRequestResponseData}
                viewDataFromSupplier={viewDataFromSupplier}
              />
            </TabPane>
          )}
          {activeTab === "7" && (
            <TabPane tabId="7" className="hl-vendor-need-view hl-kys-two-tab">
              <KysTwo viewDataFromSupplier={viewDataFromSupplier} />
            </TabPane>
          )}
          {activeTab === "6" && (
            <TabPane tabId="6" className="hl-vendor-need-view hl-kys-one-tab">
              {/* if IsExceptionalSupplier=true and ( KYS1FormStatus == 1 OR  KYS1FormStatus==30 ) And LogedinUserId==SupplierNeedFormInitiatorId then Edit button will visible and
if  KYS1FormStatus==30 OR 1 and logedinuserid == KYS1Level1ApproverList then Edit button will visible and other wise it will be not visible */}
              {
                (
                  (
                    vendorKys1Data?.IsExceptionalSupplier &&
                    (vendorKys1Data?.KYS1FormStatus == 1 || vendorKys1Data?.KYS1FormStatus == 30) &&
                    loggedInUserDetail?.EmployeeId == vendorKys1Data?.SupplierNeedFormInitiatorId
                  )
                  ||
                  (
                    (vendorKys1Data?.KYS1FormStatus == 1 || vendorKys1Data?.KYS1FormStatus == 30) &&
                    vendorKys1Data?.KYS1Level1ApproverList?.includes(parseInt(loggedInUserDetail?.EmployeeId))
                  )
                )
                &&
                vendorKys1Data?.IsKYS1FormApproved == false && (
                  <>
                    <Button title={showKysOneView ? "Edit Kys1" : "View Kys1"} className="mt10 hl-kys-btn float-right" onClick={() => setsShowKysOneView(!showKysOneView)}>
                      {showKysOneView ? "Edit Kys1" : "View Kys1"}
                    </Button>
                    <div className="clearfix"></div>
                  </>
                )}
              {showKysOneView ? (
                <KysOneView
                  viewDataFromSupplier={viewDataFromSupplier}
                // setVendorKys1Data={setVendorKys1Data} 
                />
              ) : (
                <KysOne
                  viewDataFromSupplier={viewDataFromSupplier}
                // setVendorKys1Data={setVendorKys1Data} 
                />
              )}
            </TabPane>
          )}
          {(activeTab === "8") && (
            <>
              <TabPane tabId="8" className="pt-4 hl-view-sup-page">
                <KysTwoExceptionalApprovalList />
              </TabPane>
            </>
          )}
          {activeTab === "9" && (
            <TabPane tabId="9" className="hl-vendor-need-view hl-kys-two-tab">
              <KysTwoApproval viewDataFromSupplier={viewDataFromSupplier} />
            </TabPane>
          )}
        </TabContent>
      </div>
      {activeTab === "2" && (
        <Row>
          <Col md="6">
            {showContentForm ? (
              <div className="hl-self-assessment-tbl">
                <h5 className="mt-4 mb-3">Supplier Self Assessment Summary</h5>
                <Table bordered className="hl-tbl-summary-ttl">
                  <tbody>
                    <tr>
                      {/* Render predefined columns */}
                      {columns.map((column) => (
                        <th key={column?.key}>{column?.title}</th>
                      ))}
                    </tr>
                    {/* Dynamically render table rows based on dataDynamic */}
                    {dataDynamic.map((item, index) => (
                      <tr key={index}>
                        {/* Dynamically render table cells based on predefined columns */}
                        {columns.map((column) => (
                          <td key={column.key}>{item[column?.dataIndex]}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </Table>

                <Table bordered className="hl-tbl-assessment-ttl mb-5 mt-4">
                  <tbody>
                    <tr>
                      <th className="hl-title-tooltip w-30">
                        Quality Score
                        <TooltipCustom
                          id="qualityScoreTooltip"
                          tooltipText="Percentage(%) of quality score achieved out of total quality score."
                        />
                      </th>
                      <td className="fw-semibold" style={{ color: qualityScoreForGroup1 > 60 ? '#4dc771' : '#fc5774' }}>
                        {Math.round(qualityScoreForGroup1)}%
                        {/* {qualityScoreForGroup1?.toFixed(2)}% */}
                      </td>
                    </tr>
                    <tr>
                      <th className="hl-title-tooltip w-30">
                        ESG/Sustainability Score
                        <TooltipCustom
                          id="eSGScoreTooltip"
                          tooltipText="Percentage(%) of sustainability score achieved out of total sustainability score."
                        />
                      </th>
                      <td className="fw-semibold" style={{ color: sustainabilityScoreForGroup1 > 60 ? '#4dc771' : '#fc5774' }}>
                        {/* {sustainabilityScoreForGroup1?.toFixed(2)}% */}
                        {Math.round(sustainabilityScoreForGroup1)}%
                      </td>
                    </tr>
                    <tr>
                      <th className="hl-title-tooltip w-30">
                        Overall Score
                        <TooltipCustom
                          id="overallScoreTooltip"
                          tooltipText="Percentage(%) of grand total score achieved out of overall score."
                        />
                      </th>
                      <td className="fw-semibold" style={{ color: overAllPercentage > 60 ? '#4dc771' : '#fc5774' }}>
                        {Math.round(overAllPercentage)}%
                        {/* {overAllPercentage?.toFixed(2)}% */}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            ) : (
              ""
            )}
          </Col>
          <Col md="6">
            {showContentForm ? (
              <div className="hl-self-assessment-tbl">
                <h5 className="mt-4 mb-3">Requester Assessment Summary</h5>
                <Table bordered className="hl-tbl-summary-ttl">
                  <tbody>
                    <tr>
                      {/* Render predefined columns */}
                      {columnsForRequestor.map((column) => (
                        <th key={column?.key}>{column?.title}</th>
                      ))}
                    </tr>
                    {/* Dynamically render table rows based on dataDynamic */}
                    {dataDynamicForRequestor?.map((item, index) => (
                      <tr key={index}>
                        {/* Dynamically render table cells based on predefined columns */}
                        {columnsForRequestor.map((column) => (
                          <td key={column.key}>{item[column?.dataIndex]}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <Table bordered className="hl-tbl-assessment-ttl mb-5 mt-4">
                  <tbody>
                    <tr>
                      <th className="hl-title-tooltip w-30">
                        Quality Score
                        <TooltipCustom
                          id="requesterQualityScoreTooltip"
                          tooltipText="Percentage(%) of quality score achieved out of total quality score."
                        />
                      </th>
                      <td className="fw-semibold" style={{ color: qualityScoreForGroupForRequestor > 60 ? '#4dc771' : '#fc5774' }}>
                        {Math.round(qualityScoreForGroupForRequestor)}%
                      </td>
                    </tr>
                    <tr>
                      <th className="hl-title-tooltip w-30">
                        ESG/Sustainability Score
                        <TooltipCustom
                          id="requesterSustainabilityScoreTooltip"
                          tooltipText="Percentage(%) of sustainability score achieved out of total sustainability score."
                        />
                      </th>
                      <td className="fw-semibold" style={{ color: sustainabilityScoreForGroupForRequestor > 60 ? '#4dc771' : '#fc5774' }}>
                        {Math.round(sustainabilityScoreForGroupForRequestor)}%
                        {/* {sustainabilityScoreForGroupForRequestor?.toFixed(2)}% */}
                      </td>
                    </tr>
                    <tr>
                      <th className="hl-title-tooltip w-30">
                        Overall Score
                        <TooltipCustom
                          id="requesterOverallScoreTooltip"
                          tooltipText="Percentage(%) of quality score achieved out of total quality score."
                        />
                      </th>
                      <td className="fw-semibold" style={{ color: overAllPercentageForRequestor > 60 ? '#4dc771' : '#fc5774' }}>
                        {Math.round(overAllPercentageForRequestor)}%
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            ) : (
              ""
            )}
          </Col>
        </Row>
      )}
      {activeTab === "2" && (
        <>
          <div
            class={`sf-btn-footer sticky-btn-footer hl-btm-footer ${showAssessment ? "bluefooter-butn" : ""
              } mt-5`}
          >
            <div className="text-right">
              {!showContentForm ? (
                <>
                  {showAssessment && (
                    <Button
                      className="reset cancel-btn"
                      onClick={handleBackButton}
                    >
                      <i
                        className="fa fa-long-arrow-left mr-1"
                        aria-hidden="true"
                      ></i>{" "}
                      Back
                    </Button>
                  )}
                  {!!showAssessment && (
                    <Button
                      className="btn-primary  ml-2"
                      onClick={handleGoToReview}
                    >
                      <div className="send-for-approval mr-1"></div> {(applicationRegistrationStatus !== 5 &&
                        applicationRegistrationStatus !== 6 &&
                        applicationRegistrationStatus !== 7) ? 'Preview' : 'Go to Review'}
                    </Button>
                  )}
                  {approveRequestForCorrectionCheckId &&
                    !!showAssessment &&
                    (applicationRegistrationStatus === 5 ||
                      applicationRegistrationStatus === 6) && (
                      <Button
                        type="primary"
                        className="btn-primary ml-2"
                        onClick={() => {
                          setRemarkAccept(true);
                        }}
                      >
                        <div className="send-for-approval mr-1"></div> Request
                        for Correction
                      </Button>
                    )}

                  {approveRequestForCorrectionCheckId &&
                    !!showAssessment &&
                    (applicationRegistrationStatus === 5 ||
                      applicationRegistrationStatus === 6 ||
                      applicationRegistrationStatus === 4) && (
                      <Button
                        type="primary"
                        className="btn-primary ml-2"
                        onClick={() => {
                          setShowPopupForApprove(true);
                        }}
                      >
                        <div className="send-for-approval mr-1"></div> Approve
                        Supplier Self Assessment
                      </Button>
                    )}
                </>
              ) : (
                <>
                  <Button
                    className="reset cancel-btn"
                    onClick={handleGoBackToQuestions}
                  >
                    <i
                      className="fa fa-long-arrow-left mr-1"
                      aria-hidden="true"
                    ></i>{" "}
                    Go Back to Questions
                  </Button>

                  {approveRequestForCorrectionCheckId &&
                    isAllQuestionsAnswered() &&
                    applicationRegistrationStatus === 7 && (
                      <Button
                        type="primary"
                        className="btn-primary ml-2"
                        onClick={() => {
                          setShowPopupForSubmit(true);
                        }}
                      >
                        <div class="save-icon"></div> Submit
                      </Button>
                    )}
                  {(applicationRegistrationStatus === 5 ||
                    applicationRegistrationStatus === 6) &&
                    approveRequestForCorrectionCheckId && (
                      <Button
                        type="primary"
                        className="btn-primary ml-2"
                        onClick={() => {
                          setRemarkAccept(true);
                        }}
                      >
                        <div className="send-for-approval mr-1"></div> Request
                        for Correction
                      </Button>
                    )}

                  {approveRequestForCorrectionCheckId &&
                    (applicationRegistrationStatus === 5 ||
                      applicationRegistrationStatus === 6 ||
                      applicationRegistrationStatus === 4) && (
                      <Button
                        type="primary"
                        className="btn-primary ml-2"
                        onClick={() => {
                          setShowPopupForApprove(true);
                        }}
                      >
                        <div className="send-for-approval mr-1"></div> Approve
                        Supplier Self Assessment
                      </Button>
                    )}
                </>
              )}
            </div>
          </div>{" "}
        </>
      )}
      {showPopupForSubmit && (
        <PopupMsgWrapper
          firstButtonName="Proceed"
          isOpen={showPopupForSubmit}
          closePopUp={closePopUpForSubmit}
          confirmPopup={() => handleSubmit()}
          message={
            <>
              This action will submit your Supplier Need Form.
              <br />
              <strong>Do you want to proceed?</strong>
            </>
          }
        />
      )}
      {/* {remarkApprove && (
        <PopupMsgWrapper
          setInputData={popupInputData}
          isOpen={remarkApprove}
          header={"Remark1"}
          closePopUp={closePopUp}
          confirmPopup={() => handleRequestForConfirmation(false)}
          isInputField={true} // Assuming you want an input field in your popup
        />
      )} */}

      {showPopupForCorrection && (
        <PopupMsgWrapper
          isOpen={showPopupForCorrection}
          closePopUp={closePopUpForCorrection}
          confirmPopup={onPopupConfirmForCorrection}
          message={`Are you sure you want to Request For Correction?`}
        />
      )}
      {showPopupForApprove && (
        <PopupMsgWrapper
          isOpen={showPopupForApprove}
          closePopUp={closePopUpForApprove}
          confirmPopup={() => handleRequestForConfirmation(false, true)}
          message={`Are you sure you want to Approve?`}
        />
      )}
      {remarkAccept && (
        <PopupMsgWrapper
          setInputData={popupInputData}
          isOpen={remarkAccept}
          header={"Remark"}
          closePopUp={closePopUp}
          confirmPopup={() => handleRequestForConrrection(true)}
          isInputField={true} // Assuming you want an input field in your popup
        />
      )}
    </>
  );
};
export default AssesmentForm;
